module.exports = __webpack_public_path__ + "static/media/help-text.709c8af1.svg";